import { t } from 'i18next';

import { SelectionBase } from './SelectionBase';
import { SelectBoxOption } from '../stores/SelectBoxStore';
import { AppConfiguration } from '../stores/AppConfigurationStore';
import { PersistentStore } from '../stores/PersistentStore';
import { PersistentActions } from '../actions/PersistentActions';

export class SelectionLanguage extends SelectionBase {
    protected id: string = 'language-select';

    public componentWillMount(): void {
        this.addStoreListener(PersistentStore, this.onChange);
        this.onChange();
    }

    protected onChange = (): void => {
        this.setState({
            value: PersistentStore.getState().language,
            visible: true,
            enabled: true
        });
    };

    protected getLabel(): string {
        return t('Language');
    }

    protected options(): Array<SelectBoxOption> {
        return [
            {key: 'de', name: t('German'), className: 'egr-select-option-noicon', callback: () => {PersistentActions.setLanguage('de'); }},
            {key: 'en', name: t('English'), className: 'egr-select-option-noicon', callback: () => {PersistentActions.setLanguage('en'); }},
            {key: 'es', name: t('Spanish'), className: 'egr-select-option-noicon', callback: () => {PersistentActions.setLanguage('es'); }},
            {key: 'fr', name: t('French'), className: 'egr-select-option-noicon', callback: () => {PersistentActions.setLanguage('fr'); }},
            {key: 'it', name: t('Italian'), className: 'egr-select-option-noicon', callback: () => {PersistentActions.setLanguage('it'); }},
            {key: 'nl', name: t('Dutch'), className: 'egr-select-option-noicon', callback: () => {PersistentActions.setLanguage('nl'); }},
            {key: 'pl', name: t('Polish'), className: 'egr-select-option-noicon', callback: () => {PersistentActions.setLanguage('pl'); }},
            {key: 'pt', name: t('Portuguese'), className: 'egr-select-option-noicon', callback: () => {PersistentActions.setLanguage('pt'); }},
            {key: 'ro', name: t('Romanian'), className: 'egr-select-option-noicon', callback: () => {PersistentActions.setLanguage('ro'); }},
            {key: 'tr', name: t('Turkish'), className: 'egr-select-option-noicon', callback: () => {PersistentActions.setLanguage('tr'); }},
        ].filter((language) => {
            return (
                AppConfiguration.AllowedLanguages.indexOf(language.key) !== -1
            );
        }).sort((a: SelectBoxOption, b: SelectBoxOption) => {return a.name > b.name ? 1 : -1; });
    }
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/SelectionLanguage.tsx